import { JsonProperty, ObjectMapper } from 'json-object-mapper';
import { IModel } from '../IModel';
import { Model } from '../model';
import { VideoFileContentModel } from './video-file-content.model';

export class RecruitPageConfigModel extends Model implements IModel<RecruitPageConfigModel> {
  @JsonProperty()
  public companyGroupId: string = '';

  @JsonProperty()
  public title: string = '';

  @JsonProperty()
  public description: string = '';

  @JsonProperty()
  public coverFileKey: string | null = null;

  @JsonProperty()
  public coverFileName: string | null = null;

  @JsonProperty()
  public coverFileUrl: string | null = null;

  public fileContent: VideoFileContentModel | null = null;

  @JsonProperty()
  public videoFileUrl: string | null = null;

  @JsonProperty()
  public xUrl: string | null = null;

  @JsonProperty()
  public facebookUrl: string | null = null;

  @JsonProperty()
  public instagramUrl: string | null = null;

  @JsonProperty({ name: 'linkedInUrl' })
  public linkedinUrl: string | null = null;

  static create(input: any): RecruitPageConfigModel {
    const config = ObjectMapper.deserialize<RecruitPageConfigModel>(
      RecruitPageConfigModel,
      input ?? {}
    );

    if (input && input.fileContent) {
      config.fileContent = {
        fileKey: input.fileContent.fileKey || null,
        fileName: input.fileContent.fileName || null,
      };
    } else if (input && (input.videoFileKey || input.videoFileName)) {
      config.fileContent = {
        fileKey: input.videoFileKey || null,
        fileName: input.videoFileName || null,
      };
    }

    if (input && input.urlContentCDN) {
      config.videoFileUrl = input.urlContentCDN;
    } else if (input && input.videoFileUrl && !config.videoFileUrl) {
      config.videoFileUrl = input.videoFileUrl;
    }

    if (input && input.linkedInUrl != null && input.linkedInUrl !== '') {
      config.linkedinUrl = input.linkedInUrl;
    } else if (input && input.linkedinUrl != null && input.linkedinUrl !== '') {
      config.linkedinUrl = input.linkedinUrl;
    }

    return config;
  }

  public toJSON(): string {
    return ObjectMapper.serialize(this) as string;
  }
}
